import { isGenericChannelId } from 'conversations-thread-data/channel-configuration/public/types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useAsyncGenericChannelsWithCapabilities } from 'composer-data/channel-capabilities/public/hooks';
import Raven from 'raven-js';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const ChannelLabel = ({
  genericChannelId
}) => {
  const hasGenericChannelId = genericChannelId && isGenericChannelId(genericChannelId);
  const {
    data,
    error
  } = useAsyncGenericChannelsWithCapabilities();
  const genericChannel = data && genericChannelId && isGenericChannelId(genericChannelId) ? data[genericChannelId] : null;
  if (error) {
    Raven.captureException(error, {
      extra: {
        genericChannelId,
        data
      }
    });
  }
  if (hasGenericChannelId) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: genericChannel ? genericChannel.displayName : null
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "composer-ui.capability-editor.channel-label.unset"
  });
};
ChannelLabel.displayName = 'ChannelLabel';